import React from 'react'
import { AppRouter } from './routers/AppRouter'
import { Provider } from 'react-redux'
import { store } from './store/store'
import './styles/App.scss';

export const App = () => {
    return (
        <Provider store={store}>
            <AppRouter />
        </Provider>
    )
}


export default App;
